import type { PluginExports } from 'graylog-web-plugin/plugin';

import validLicensePresent from 'license/ValidLicensePresent';

const Component: React.ComponentType = () => null;

const bindings: PluginExports = {
  'components.upsell.wrapper': [{ useCondition: validLicensePresent, component: Component }],
};

export default bindings;
